module.exports = __webpack_public_path__ + "static/media/icon-options.bbaa66b6.svg";